import React from 'react';
import './WorkIntegrations.css';

// ייבוא תמונות
import Salesforce from '../../../assets/Salesforce.png';
import AppStore from '../../../assets/AppStore.png';
import GooglePlay from '../../../assets/GooglePlay.png';
import Dynamics365 from '../../../assets/Dynamics365.png';
import SAP from '../../../assets/SAP.png';
import GoogleMyBusiness from '../../../assets/GoogleMyBusiness.png';
import Meta from '../../../assets/Meta.png';
import WhatsApp from '../../../assets/WhatsApp.png';
import monday from '../../../assets/mondaynew.png';
import make from '../../../assets/make.jpg';
import PowerAutomate from '../../../assets/PowerAutomate.png';
import zapier from '../../../assets/zapier.png';
import office from '../../../assets/office-new.jpg';
import googleSheet from '../../../assets/google-sheets-logo.png';
import HubSpot from '../../../assets/HubSpot-Logo.png';
import openai from '../../../assets/openai-icon.png';
import shopify from '../../../assets/shopify-logo.png';
import Azure from '../../../assets/azure.jpg';
import GCP from '../../../assets/google-cloud-icon.png';
import sql from '../../../assets/sql.jpg';
// מערך האינטגרציות עם משתנים מיובאים
const integrations = [
  { name: "Salesforce", image: Salesforce },
  // { name: "App Store", image: AppStore },
  // { name: "Google Play", image: GooglePlay },
  { name: "Monday", image: monday },
  { name: "Power Automate", image: PowerAutomate },
  { name: "Make", image: make },
  { name: "Zapier", image: zapier },
  { name: "Office", image: office },
  { name: "Dynamics 365", image: Dynamics365 },
  { name: "Azure", image: Azure },
  { name: "SQL", image: sql },
  { name: "Open.Ai", image: openai },
  { name: "Google Sheets", image: googleSheet },
  { name: "Google Cloud Platform", image: GCP },
  { name: "SAP", image: SAP },
  { name: "HubSpot", image: HubSpot },
  { name: "Shopify", image: shopify },

  { name: "Meta", image: Meta },

];

const WorkIntegrations = () => {
  return (
    <div className="work-integrations-container">
    <h2 className="work-integrations-title">אינטגרציות לעבודה אפקטיבית ושותפות</h2>
    <div className="integration-group-wrapper">
      <div className="work-integrations-grid">
        {integrations.map((item, index) => (
          <div key={index} className="integration-icon">
            <img src={item.image} alt={item.name} />
          </div>
        ))}
      </div>
    </div>
  </div>  
  );
};

export default WorkIntegrations;
